module.exports = "<table class=\"table table-bordered text-center mx-auto mb-0\">\r\n  <thead class=\"bg-ssn text-white\">\r\n    <tr>\r\n      <th class=\"py-1\">\r\n        <h5 class=\"mb-0\">Cargo</h5>\r\n      </th>\r\n    </tr>\r\n  </thead>\r\n</table>\r\n<div class=\"table-responsive\">\r\n  <ng2-smart-table [settings]=\"cargoTableSettings\" [source]=\"cargoDataSource\"></ng2-smart-table>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-content/content-container/port-call/registration/forms/cargo/cargo-table/cargo-table.component.html
// module id = ./src/app/main-content/content-container/port-call/registration/forms/cargo/cargo-table/cargo-table.component.html
// module chunks = main